import { render, staticRenderFns } from "./delete-file-button.vue?vue&type=template&id=8eaeefc6&scoped=true&"
import script from "./delete-file-button.vue?vue&type=script&lang=js&"
export * from "./delete-file-button.vue?vue&type=script&lang=js&"
import style0 from "./delete-file-button.vue?vue&type=style&index=0&id=8eaeefc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eaeefc6",
  null
  
)

export default component.exports